import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/shared/Header';
import HomePage from './components/HomePage';
import JoinPage from './components/JoinPage';
import SessionPage from './components/board/SessionPage';
import ReportsPage from './components/reporting/ReportsPage';
import TeamPage from './pages/TeamPage';
import TemplatesPage from './pages/TemplatesPage';
import './index.css';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="app-shell">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/join/:sessionId" element={<JoinPage />} />
            <Route path="/session/:sessionId" element={<SessionPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/team/:teamId" element={<TeamPage />} />
            <Route path="/templates" element={<TemplatesPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}
